import { createStore } from 'vuex'
import api from '@/api/login'

export default createStore({
  // 全局状态
  state: {
    // 路由是否已生成
    hasRoutes: false,

    // 标签页相关状态
    editableTabsValue: '/', // 当前激活的标签页
    editableTabs: [
      {
        title: '首页',
        name: '/',
      }
    ],

    // 需要缓存的视图组件名称列表
    cachedViews: ['Home'],  // 默认缓存首页

    // 各个页面的状态管理
    storeListState: null, // 门店列表页状态
    pageStates: {}, // 通用页面状态存储

    // 营业执照列表页状态
    licenseListState: {
      queryForm: {
        license_number: '',
        store_id: [],
        license_status: '',
        responsible_person: '',
        issue_date: '',
        expiry_date: '',
        page: 1,
        page_size: 200,
        days_remaining: ''
      },
      selectedStoreNames: '',
      tableData: [],
      total: 0,
      pageSize: 200,
      currentPage: 1,
      tableHeight: 0,
      isCollapse: true
    },

    // 商品列表页状态
    itemListState: {
      formInline: {
        name: '',
        category: []
      },
      categoryOptions: [], // 类别选项
      tableData: [], // 表格数据
      total: 0, // 总数
      currentPage: 1, // 当前页
      pageSize: 200, // 每页条数
      isCollapse: true, // 折叠状态
      multipleSelection: [], // 多选数据
      tableHeight: 0 // 表格高度
    },

    orderListState: null, // 订单列表页状态

    // 单品商品销售页状态
    goodsSaleState: {
      formInline: {
        item_name: '',
        store_name: '',
        region_name: '',
        item_category: []
      },
      tableData: [],
      total: 0,
      pageSize: 500,
      currentPage: 1,
      tableHeight: 0,
      dateRange: [],
      regionValue: [],
      regionOptions: [],
      categoryOptions: [],
      isCollapse: true,
      selectedDetailRow: null,
      categoryDetailData: [],
      categoryDetailTitle: '',
      categoryDetailTotal: 0,
      categoryDetailPage: 1,
      categoryDetailPageSize: 50,
      displayImages: []
    },

    // 用户列表页状态
    userListState: {
      formInline: {
        name: '',
        category: []
      },
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 200,
      isCollapse: true
    },

    // 角色列表页状态
    roleListState: {
      formInline: {
        name: '',
        category: []
      },
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 200,
      isCollapse: true
    },

    // 合同列表页状态
    contractListState: {
      queryForm: {
        contract_number: '',
        store_id: [],
        contract_status: '',
        responsible_person: '',
        start_date: '',
        end_date: '',
        rent: '',
        page: 1,
        page_size: 200,
        days_remaining: ''
      },
      selectedStoreNames: '',
      tableData: [],
      total: 0,
      pageSize: 200,
      currentPage: 1,
      tableHeight: 0,
      isCollapse: true
    },

    inorderListState: null, // 订单列表页状态

    deliveryCostsState: {
      formState: {
        route_name: '',
        delivery_date: '',
        total_cost: 0,
        store_amounts: []
      },
      allocationResults: []
    },

    mapState: {
      listQuery: {
        type: undefined,
        store_ids: []
      },
      selectedStoreNames: '',
      searchAddress: '',
      stores: [],          // 存储门店数据
      competitors: [],     // 存储竞争对手数据
      markPoints: [],
      isAddingMode: false,
      showCompetitors: false,
      center: null,        // 存储地图中心点
      zoom: null          // 存储缩放级别
    },

    contendState: {
      isAddingMode: false,
      locationAddress: '',
      locationData: {},
      currentEditData: {},
      isEdit: false,
      currentEditId: null,
      competitors: [],
      center: [120.699279, 27.993849],
      zoom: 11,
      // 添加临时标记点的状态
      tempMarkerData: null  // 用于存储临时标记点的位置和信息
    },

    // 水电费列表页状态
    utilitiesListState: {
      queryForm: {
        store_id: [],
        type: '',
        account_number: '',
        month: '',
        page: 1,
        page_size: 10
      },
      selectedStoreNames: '',
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableHeight: 0,
      sortBy: '',
      sortOrder: ''
    },

    // 水电费明细页状态
    utilitiesDetailState: {
      accountInfo: null,
      accountNumber: '',
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      tableHeight: 0,
      sortBy: '',
      sortOrder: ''
    },

    // 通讯录页面状态
    contactsListState: {
      searchForm: {
        name: '',
        position: '',
        department_id: [],
        status: '',
        contact_number: '',
      },
      memberList: [],
      total: 0,
      pageSize: 20,
      currentPage: 1,
      selectedDepartment: null,
      departmentData: []
    },

    // 添加员工详情页状态
    staffDetailState: {
      activeTab: 'basic',
      staffData: {},
      currentUserId: null
    },

    // 添加首页数据状态
    homeData: {
      initialized: false,
      lastUpdated: null,
      dateRange: null,
      data: {
        businessData: null,
        salesChart: null,
        deliveryChart: null,
        storeRank: null,
        itemRank: null
      }
    },

    // 库存调整列表页状态
    inventoryAdjustmentState: {
      queryForm: {
        store_id: [],
        adjustment_type: '',
        adjustment_direction: '',
        date_range: '',
        page: 1,
        page_size: 200
      },
      selectedStoreNames: '',
      tableData: [],
      total: 0,
      pageSize: 200,
      currentPage: 1,
      tableHeight: 0,
      isCollapse: true,
      sortBy: '',
      sortOrder: ''
    },

    // 目标跟踪页状态
    targetTrackerState: null,
  },

  // getter 方法
  getters: {
    // 获取 token
    GET_TKEN: state => {
      return sessionStorage.getItem("token")
    },
    // 获取菜单列表
    GET_MENULIST: state => {
      return JSON.parse(sessionStorage.getItem("menuList"));
    },
    // 获取用户信息
    GET_USERINFO: state => {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    },
    // 获取权限信息
    GET_PERMS: state => {
      let perms = JSON.parse(sessionStorage.getItem("perms"));
      return perms;
    },
    // 获取指定页面的状态
    getPageState: (state) => (pageName) => {
      return state.pageStates[pageName];
    },
    getHomeData: state => componentName => {
      return state.homeData.data[componentName];
    },
    isHomeDataInitialized: state => {
      return state.homeData.initialized;
    },
    getHomeDateRange: state => {
      return state.homeData.dateRange;
    },
    isHomeDataExpired: state => {
      const now = Date.now();
      const lastUpdated = state.homeData.lastUpdated;
      const expireTime = 30 * 60 * 1000; // 30分钟过期
      return !lastUpdated || (now - lastUpdated > expireTime);
    }
  },

  // mutation 方法（同步修改状态）
  mutations: {
    // 设置 token
    SET_TOKEN: (state, token) => {
      sessionStorage.setItem("token", token);
    },
    // 设置菜单列表
    SET_MENULIST: (state, menuList) => {
      state.menuList = menuList;
      sessionStorage.setItem("menuList", JSON.stringify(menuList));
    },
    // 设置用户信息
    SET_USERINFO: (state, userInfo) => {
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
    },
    // 设置权限信息
    SET_PERMS: (state, perms) => {
      sessionStorage.setItem("perms", JSON.stringify(perms));
    },
    // 设置路由状态
    SET_ROUTES_STATE: (state, hasRoutes) => {
      state.hasRoutes = hasRoutes
    },

    // 标签页相关操作
    ADD_TABS: (state, tab) => {
      // 检查标签是否已存在
      const existingTab = state.editableTabs.find(item => {
        if (tab.path.includes('/detail/')) {
          return item.name === tab.path;
        }
        return item.name === tab.path;
      });

      if (!existingTab) {
        state.editableTabs.push({
          title: tab.name,
          name: tab.path,
          params: tab.params  // 保存路由参数
        });
      }
      state.editableTabsValue = tab.path;
    },
    DEL_TABS: (state, path) => {
      state.editableTabs = state.editableTabs.filter(item => item.name !== path);
    },
    RESET_TAB: (state) => {
      state.editableTabsValue = '/'
      state.editableTabs = [{
        title: '首页',
        name: '/',
      }]
    },

    // 缓存视图相关操作
    ADD_CACHED_VIEW(state, view) {
      if (state.cachedViews.includes(view)) return
      state.cachedViews.push(view)
    },
    DEL_CACHED_VIEW(state, view) {
      const index = state.cachedViews.findIndex(v => v.name === view.name)
      if (index > -1) {
        state.cachedViews.splice(index, 1)
      }
    },
    RESET_CACHED_VIEW(state) {
      state.cachedViews = ['门店管理', '商品档案', '销售订单', 'contacts'];
    },

    // 各页面状态更新操作
    UPDATE_STORE_LIST_STATE(state, newState) {
      state.storeListState = newState;
    },
    CLEAR_STORE_LIST_STATE(state) {
      state.storeListState = null;
    },
    SET_PAGE_STATE(state, { pageName, pageState }) {
      state.pageStates[pageName] = pageState;
    },
    CLEAR_PAGE_STATE(state, pageName) {
      delete state.pageStates[pageName];
    },
    UPDATE_ITEM_LIST_STATE(state, newState) {
      state.itemListState = newState;
    },
    CLEAR_ITEM_LIST_STATE(state) {
      state.itemListState = {/* 初始状态 */ };
    },
    // 订单列表状态更新（使用对象合并方式）
    UPDATE_ORDER_LIST_STATE(state, payload) {
      state.orderListState = {
        ...(state.orderListState || {}),
        ...payload
      };
    },
    CLEAR_ORDER_LIST_STATE(state) {
      state.orderListState = null;
    },
    // 合同列表状态更新（使用对象合并方式）
    UPDATE_CONTRACT_LIST_STATE(state, newState) {
      state.contractListState = { ...state.contractListState, ...newState };
    },
    CLEAR_CONTRACT_LIST_STATE(state) {
      state.contractListState = {/* 初始状态 */ };
    },
    UPDATE_INORDER_LIST_STATE(state, payload) {
      state.inorderListState = payload;
    },
    CLEAR_INORDER_LIST_STATE(state) {
      state.inorderListState = null;
    },
    UPDATE_DELIVERY_COSTS_STATE(state, newState) {
      state.deliveryCostsState = { ...state.deliveryCostsState, ...newState };
    },
    CLEAR_DELIVERY_COSTS_STATE(state) {
      state.deliveryCostsState = null;
    },
    UPDATE_MAP_STATE(state, newState) {
      state.mapState = { ...state.mapState, ...newState };
    },
    CLEAR_MAP_STATE(state) {
      state.mapState = null;
    },
    UPDATE_CONTEND_STATE(state, newState) {
      state.contendState = { ...state.contendState, ...newState };
    },
    CLEAR_CONTEND_STATE(state) {
      state.contendState = null;
    },
    // 营业执照列表状态更新
    UPDATE_LICENSE_LIST_STATE(state, newState) {
      state.licenseListState = { ...state.licenseListState, ...newState };
    },
    CLEAR_LICENSE_LIST_STATE(state) {
      state.licenseListState = null;
    },
    // 水电费列表状态更新
    UPDATE_UTILITIES_LIST_STATE(state, newState) {
      state.utilitiesListState = { ...state.utilitiesListState, ...newState };
    },
    CLEAR_UTILITIES_LIST_STATE(state) {
      state.utilitiesListState = {
        queryForm: {
          store_id: [],
          type: '',
          account_number: '',
          month: '',
          page: 1,
          page_size: 10
        },
        selectedStoreNames: '',
        tableData: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        tableHeight: 0,
        sortBy: '',
        sortOrder: ''
      };
    },
    // 水电费明细状态更新
    UPDATE_UTILITIES_DETAIL_STATE(state, newState) {
      state.utilitiesDetailState = { ...state.utilitiesDetailState, ...newState };
    },
    CLEAR_UTILITIES_DETAIL_STATE(state) {
      state.utilitiesDetailState = {
        accountInfo: null,
        accountNumber: '',
        tableData: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        tableHeight: 0,
        sortBy: '',
        sortOrder: ''
      };
    },
    // 通讯录列表状态更新
    UPDATE_CONTACTS_LIST_STATE(state, newState) {
      state.contactsListState = {
        ...state.contactsListState,
        ...newState,
        searchForm: {
          ...state.contactsListState.searchForm,
          ...(newState.searchForm || {})
        }
      };
    },
    CLEAR_CONTACTS_LIST_STATE(state) {
      state.contactsListState = null
    },
    UPDATE_TAB_TITLE(state, { path, title }) {
      const tab = state.editableTabs.find(tab => tab.name === path)
      if (tab) {
        tab.title = title
      }
    },
    REMOVE_TAB(state, { path }) {
      const index = state.editableTabs.findIndex(tab => tab.name === path)
      if (index > -1) {
        state.editableTabs.splice(index, 1)
      }
    },
    // 更新员工详情页状态
    UPDATE_STAFF_DETAIL_STATE(state, newState) {
      state.staffDetailState = {
        ...state.staffDetailState,
        ...newState
      }
    },
    // 清除员工详情页状态
    CLEAR_STAFF_DETAIL_STATE(state) {
      state.staffDetailState = {
        activeTab: 'basic',
        staffData: {},
        currentUserId: null
      }
    },
    SET_HOME_DATA(state, { componentName, data }) {
      state.homeData.data[componentName] = data;
      state.homeData.lastUpdated = Date.now();
    },
    SET_HOME_INITIALIZED(state, value) {
      state.homeData.initialized = value;
    },
    SET_HOME_DATE_RANGE(state, dateRange) {
      state.homeData.dateRange = dateRange;
    },
    CLEAR_HOME_DATA(state) {
      state.homeData = {
        initialized: false,
        lastUpdated: null,
        dateRange: null,
        data: {
          businessData: null,
          salesChart: null,
          deliveryChart: null,
          storeRank: null,
          itemRank: null
        }
      };
    },
    SET_HAS_ROUTES(state, value) {
      state.hasRoutes = value
    },
    // 库存调整状态更新
    UPDATE_INVENTORY_ADJUSTMENT_STATE(state, newState) {
      state.inventoryAdjustmentState = { ...state.inventoryAdjustmentState, ...newState }
    },
    // 清除库存调整状态
    CLEAR_INVENTORY_ADJUSTMENT_STATE(state) {
      state.inventoryAdjustmentState = null
    },
    // 商品销售页状态更新
    UPDATE_GOODS_SALE_STATE(state, payload) {
      state.goodsSaleState = {
        ...(state.goodsSaleState || {}),
        ...payload
      };
    },
    CLEAR_GOODS_SALE_STATE(state) {
      state.goodsSaleState = null;
    },
    // 目标跟踪状态更新
    UPDATE_TARGET_TRACKER_STATE(state, newState) {
      state.targetTrackerState = { ...(state.targetTrackerState || {}), ...newState };
    },
    // 清除目标跟踪状态
    CLEAR_TARGET_TRACKER_STATE(state) {
      state.targetTrackerState = null;
    },
  },

  // action 方法（异步操作）
  actions: {
    // 缓存视图相关操作
    addCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view);
    },
    removeCachedView({ commit }, view) {
      commit('DEL_CACHED_VIEW', view);
    },
    resetCachedView({ commit }) {
      commit('RESET_CACHED_VIEW');
    },
    // 页面状态保存操作
    savePageState({ commit }, { pageName, pageState }) {
      commit('SET_PAGE_STATE', { pageName, pageState });
    },
    clearPageState({ commit }, pageName) {
      commit('CLEAR_PAGE_STATE', pageName);
    },
    saveHomeData({ commit }, { componentName, data }) {
      commit('SET_HOME_DATA', { componentName, data });
    },
    setHomeDateRange({ commit }, dateRange) {
      commit('SET_HOME_DATE_RANGE', dateRange);
    },
    clearHomeData({ commit }) {
      commit('CLEAR_HOME_DATA');
    },
    // 生成路由的 action
    generateRoutes({ commit }, menus) {
      return new Promise((resolve) => {
        // 这里可以根据菜单权限生成路由
        const accessRoutes = [] // 这里添加你的动态路由逻辑

        resolve(accessRoutes)
      })
    },
    // 获取用户信息
    async getUserInfo({ commit }, userId = null) {
      try {
        console.log('开始获取用户信息, userId:', userId);
        // 从sessionStorage获取token
        const token = window.sessionStorage.getItem('token');
        
        if (!token) {
          console.error('获取用户信息失败: 没有token');
          return { code: 401, msg: '未登录或登录已过期' };
        }
        
        // 如果没有传递userId，尝试从sessionStorage获取
        if (!userId) {
          userId = window.sessionStorage.getItem('userId');
          console.log('从sessionStorage获取userId:', userId);
        }
        
        // 调用获取用户信息API，传递userId
        const result = await api.api_getUserInfo(userId);
        console.log('获取用户信息结果:', result);
        
        if (result.code === 200) {
          // 将用户信息保存到sessionStorage
          window.sessionStorage.setItem('userSerializer', JSON.stringify(result.user));
          window.sessionStorage.setItem('menuList', JSON.stringify(result.menuList));
          window.sessionStorage.setItem('perms', JSON.stringify(result.perms));
          window.sessionStorage.setItem('roles', result.roles);
          
          // 标记路由已生成
          commit('SET_HAS_ROUTES', true);
          return result;
        } else {
          console.error('获取用户信息失败:', result.msg);
          // 清除token
          window.sessionStorage.removeItem('token');
          return { code: result.code, msg: result.msg || '获取用户信息失败' };
        }
      } catch (error) {
        console.error('获取用户信息出错:', error);
        // 清除token
        window.sessionStorage.removeItem('token');
        return { code: 500, msg: '获取用户信息出错' };
      }
    }
  },

  // 模块
  modules: {
    // 可以添加子模块
  },
})
